import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowTopRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8668 6.43052L4.00388 13.2935C3.50536 13.792 2.69709 13.792 2.19857 13.2935C1.70005 12.7949 1.70005 11.9867 2.19857 11.4881L9.06368 4.62304L5.24005 4.54313C4.49825 4.50516 4.08062 4.03497 4.08938 3.39247C4.09668 2.74851 4.66617 2.2199 5.26925 2.2126C5.87233 2.2053 11.9849 2.35424 11.9849 2.35424C12.3046 2.34986 12.5952 2.4769 12.804 2.68572C13.0114 2.89307 13.1384 3.18366 13.1355 3.50491C13.1355 3.50491 13.2845 9.61743 13.2757 10.219C13.2684 10.8221 12.7398 11.3916 12.0958 11.3989C11.4533 11.4077 10.9831 10.99 10.9466 10.2497L10.8668 6.43052Z",
		fill: "currentColor"
	})
});
export default SvgIconArrowTopRight;
